import { createSlice } from "@reduxjs/toolkit";


const discountSlice = createSlice({
  name: "discount",
  initialState: {
    type: "Discount",
    allDiscounts: [],      // full list as returned by API
    discountList: [],      // filtered list shown in UI
    selectedDiscount: null,
    discountPrice: 0,
    isDiscountApplied: false,
    isLoading: false,
    searchTerm: "",
  },
  reducers: {
    setDiscountList: (state, action) => {
      // keep both the original list and the filtered list in sync
      state.allDiscounts = action.payload || [];
      state.discountList = action.payload || [];
    },
    setSelectedDiscount: (state, action) => {
      state.selectedDiscount = action.payload;
    },
    setDiscountPrice: (state, action) => {
      state.discountPrice = action.payload;
    },
    searchDiscountByName: (state, action) => {
      const searchTerm = (action.payload || "").toLowerCase();
      state.searchTerm = action.payload || "";
      if (!searchTerm) {
        // reset to full list when searchTerm empty
        state.discountList = state.allDiscounts;
        return;
      }
      state.discountList = state.allDiscounts.filter((discount) => {
        return (discount?.name || "").toLowerCase().includes(searchTerm);
      });
    },
    resetDiscountSearch: (state) => {
      state.searchTerm = "";
      state.discountList = state.allDiscounts;
    },
  },
});

export const { setDiscountList, setSelectedDiscount, setDiscountPrice, searchDiscountByName, resetDiscountSearch } = discountSlice.actions;
export default discountSlice.reducer;
